import { render, staticRenderFns } from "./StationsData.vue?vue&type=template&id=37a0001b&scoped=true"
import script from "./StationsData.vue?vue&type=script&lang=js"
export * from "./StationsData.vue?vue&type=script&lang=js"
import style0 from "./StationsData.vue?vue&type=style&index=0&id=37a0001b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37a0001b",
  null
  
)

export default component.exports